import React, { useEffect, useState } from 'react';
import { ModuleTitleUI, ToggleUI } from '../common';
import {
  Card,
  CardContent,
  Divider,
  Grid,
  withStyles,
} from '@material-ui/core';
import { ApplicationInstalledItem } from './subcomponents/ApplicationInstalledItem';
import { CardAplication } from './subcomponents/CardAplication';
import { ModalInstallApp } from './subcomponents/ModalInstallApp';
import { ModalUninstallApp } from './subcomponents/ModalUninstallApp';
import { connect, useSelector } from 'react-redux';
import {
  applications_amplitude_events,
  createAmplitudeEventWithDevice,
} from '../amplitude';
import {
  aplicacionesObtener,
  aplicacionesActivasObtener,
} from '../../store/actions';
import { WrapperLayout } from '../../layouts/WrapperLayout';

const Applications_ = ({
  classes,
  history,
  getApplications,
  getApplicationsActives,
}) => {
  const [error, setError] = useState(false);
  const [loadingApps, setLoadingApps] = useState(true);
  const [loadingAppsActives, setLoadingAppsActives] = useState(true);
  const [openInstallApp, setOpenInstallApp] = useState(false);
  const [openUninstallApp, setOpenUninstallApp] = useState(false);
  const [appSelected, setAppSelected] = useState({});
  const [appList, setAppList] = useState([]);
  const [appActivesList, setAppActivesList] = useState([]);
  const idCountry =
    useSelector((state) => state.tienda.Country_idCountry) || 'ARG';

  useEffect(() => {
    getApplications({ idCountry: idCountry }, (err, resp) => {
      if (err) {
        setError(true);
      } else {
        const applications = resp.data?.filter(
          (app) => app.Status === 'ready' && idCountry === app.Country
        );

        setAppList(applications);
        setLoadingApps(false);
      }
    });

    getApplicationsActives((err, resp) => {
      if (err) {
        setError(true);
      } else {
        setAppActivesList(resp.data.applications);
        setLoadingAppsActives(false);
      }
    });
  }, [idCountry]);

  const handleOpenModal = ({ appId, isInstall }) => {
    const appFiltered = appList.filter((app) => app.Appid === appId)[0];
    setAppSelected(appFiltered);

    if (isInstall) {
      setOpenInstallApp(true);
      createAmplitudeEventWithDevice(
        applications_amplitude_events.aplicaciones_instalar.event_name,
        {
          aplicacion: `(${appFiltered.Name})`,
        }
      );
    } else {
      setOpenUninstallApp(true);
      createAmplitudeEventWithDevice(
        applications_amplitude_events.aplicaciones_desinstalar.event_name,
        {
          aplicacion: `(${appFiltered.Name})`,
        }
      );
    }
  };

  const hasInstalledApps = appActivesList.length > 0;

  return (
    <WrapperLayout error={error} loading={loadingApps || loadingAppsActives}>
      <ModalInstallApp
        app={appSelected}
        history={history}
        open={openInstallApp}
        modalHandler={setOpenInstallApp}
      />
      <ModalUninstallApp
        history={history}
        open={openUninstallApp}
        modalHandler={setOpenUninstallApp}
      />
      <Grid container>
        <Grid item xs={12}>
          <ModuleTitleUI
            classes={{ module_box: classes.moduleTitle }}
            title="Aplicaciones"
            subtitles={[
              'Ampliá los límites de tu tienda online con nuevas funcionalidades.',
              'No importa si sos un emprendedor que recién comienza o uno experimentado, en esta sección vas a encontrar herramientas que te ayudarán a hacer crecer tu negocio.',
            ]}
          />
          {/* Instaladas */}
          <ToggleUI show={hasInstalledApps}>
            <Card className={classes.card}>
              <CardContent className={classes.card_content}>
                <h3 className={classes.cardTitle}>Mis integraciones</h3>
                <Divider className={classes.cardDivider} variant="fullWidth" />
                <Grid component="ul" container>
                  {appList.map((app, key) => {
                    if (appActivesList.includes(app.Appid)) {
                      return (
                        <ApplicationInstalledItem
                          key={key}
                          app={app}
                          history={history}
                          handleOpenModal={() =>
                            handleOpenModal({
                              appId: app.Appid,
                              isInstall: false,
                            })
                          }
                        />
                      );
                    }

                    return null;
                  })}
                </Grid>
              </CardContent>
            </Card>
          </ToggleUI>

          {/* Para Instalar */}
          {appList.map((app, key) => {
            if (appActivesList.includes(app.Appid)) {
              return null;
            }

            return (
              <CardAplication
                app={app}
                key={key}
                handleOpenModal={() =>
                  handleOpenModal({
                    appId: app.Appid,
                    isInstall: true,
                  })
                }
                history={history}
              />
            );
          })}
        </Grid>
      </Grid>
    </WrapperLayout>
  );
};

const styles = (theme) => ({
  card: theme.card.card,
  card_content: {
    ...theme.card.card_content,
    '& ul': {
      padding: '0px',
      margin: '0px',
    },
  },
  moduleTitle: {
    marginBottom: '48px',
  },
  cardTitle: {
    fontSize: '24px',
    fontWeight: 400,
    color: '#383838',
    margin: '0px 0px 24px',
  },
  cardDivider: {
    marginBottom: '24px',
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    getApplicationsActives: (callback) =>
      dispatch(aplicacionesActivasObtener(callback)),
    getApplications: (data, callback) =>
      dispatch(aplicacionesObtener(data, callback)),
  };
};

export const Applications = withStyles(styles)(
  connect(null, mapDispatchToProps)(Applications_)
);
